module.exports = __webpack_public_path__ + "img/sb06.8be42a5b.png";